import { PLATFORM_SLOT, type SuggestedTaskResp } from "@/types/suggestedTasks.ts";

/**
 * A prompt with its platform slot filled in.
 *
 * Some prompts only read as a real request once they name where the work
 * happens — "Find a message someone sent me on Slack". The server sends the
 * template and the candidates; picking one is the client's job, so the example
 * can vary later without touching the API.
 *
 * Falls back to stripping the slot rather than rendering it. The catalog
 * guarantees a token only ever ships with values to fill it, but a literal
 * `{platform}` on a card is bad enough to be worth a belt as well as braces.
 */
export const fillPlatform = (task: SuggestedTaskResp): string => {
  if (!task.shortPrompt.includes(PLATFORM_SLOT)) return task.shortPrompt;
  const [platform] = task.examplePlatforms;
  return platform
    ? task.shortPrompt.replace(PLATFORM_SLOT, platform)
    : task.shortPrompt
        .replace(PLATFORM_SLOT, "")
        .replace(/\s{2,}/g, " ")
        .trim();
};
